/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Replacetitle3Inputs */

const en_settings_reportingapikeys_generate_replacetitle3 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Replacetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace existing key?`)
};

/**
* | output |
* | --- |
* | "Replace existing key?" |
*
* @param {Settings_Reportingapikeys_Generate_Replacetitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_replacetitle3 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Replacetitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Replacetitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_replacetitle3(inputs)
});
export { settings_reportingapikeys_generate_replacetitle3 as "settings_reportingApiKeys_generate_replaceTitle" }